export default __webpack_public_path__ + "static/media/Ballroll_00361.c5fafa71.png";